import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

// Utils
import faqUrl from '@/utils/urls/faqUrl';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';
import { url_faq_twitter_impressions_data } from '@/lib/urls/faqUrls';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const impressionsConfig = {
    name: 'kpi.twitter.total_impressions',
    id: 'impressions',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.twitter.tooltip_total_impressions"
            components={{
                br: <br />,
                a: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                        className="text-icoBlue underline"
                        target="_blank"
                        href={faqUrl(url_faq_twitter_impressions_data)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
